exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.台語寶鑑-row{width:100%}div.台語寶鑑-col,div.台語寶鑑-row{float:left;height:auto;text-align:center}div.台語寶鑑-col{width:50%;box-sizing:content-box}div.台語寶鑑-button{display:inline-block;width:250px;height:250px;background-color:#fff;border-radius:10px;border:2px solid #ccc;margin:40px 0}div.台語寶鑑-button:hover{background-color:#eee}div.台語寶鑑-button-ico{float:left;width:100%;height:65%;background-position:bottom;background-repeat:no-repeat;background-size:30%}div.台語寶鑑-button-name{float:left;width:100%;height:auto;font-size:2em;margin-top:10%}div.台語寶鑑-col a{color:#000}@media only screen and (max-width:600px){div.台語寶鑑-col{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/Ogilvy/主題/台語寶鑑.css
// module id = 670
// module chunks = 0